<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <button mat-icon-button class="modal-close-button" (click)="onEventClose()" aria-label="Close" matRipple="false">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <!-- Contenido del modal -->
  <mat-dialog-content class="modal-content">
    <div class="modal-form">
      <ngx-intl-tel-input 
        [cssClass]="'form-control form-control-phone'"
        [preferredCountries]="preferredCountries" 
        [enableAutoCountrySelect]="true" 
        [enablePlaceholder]="true"
        [customPlaceholder]="inputLabel | translate"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" 
        [selectFirstCountry]="false"
        [selectedCountryISO]="selectedCountryISO" 
        [maxLength]="15"
        [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        name="phone"
        [formControl]="phoneControl">
      </ngx-intl-tel-input>
    </div>
  </mat-dialog-content>

  <!-- Acciones del modal -->
  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading" 
      [iconPosition]="false" 
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || !phoneControl.valid" 
      [iconPosition]="false" 
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>
